"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var glctx;
function getWebGLContext() {
    if (!glctx) {
        try {
            const canvas = document.createElement("canvas");
            if (!canvas)
                throw new Error("unable to create canvas");
            const gl2 = canvas.getContext("webgl2");
            if (gl2 && typeof WebGL2RenderingContext !== "undefined") {
                console.debug("your browser supports WebGL2");
                glctx = gl2;
            }
            else {
                console.debug("your browser doesn't support WebGL2");
                const gl = canvas.getContext("webgl");
                if (!gl)
                    throw new Error("unable to get context");
                glctx = gl;
            }
        }
        catch (_a) {
            throw new Error("unable to get WebGL context from canvas");
        }
    }
    return glctx;
}
exports.getWebGLContext = getWebGLContext;
function setWebGLContext(ctx) {
    return (glctx = ctx ? ctx : getWebGLContext());
}
exports.setWebGLContext = setWebGLContext;
function isWebGL2() {
    return typeof WebGL2RenderingContext !== "undefined" && getWebGLContext() instanceof WebGL2RenderingContext;
}
exports.isWebGL2 = isWebGL2;
var maxRenderBufferSize = 0;
function getMaxRenderBufferSize() {
    if (!maxRenderBufferSize) {
        const gl = getWebGLContext();
        maxRenderBufferSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);
        console.debug(`MAX_RENDERBUFFER_SIZE: '${maxRenderBufferSize}'`);
    }
    return maxRenderBufferSize;
}
exports.getMaxRenderBufferSize = getMaxRenderBufferSize;
//# sourceMappingURL=context.js.map